import { useDeleteEventMutation } from '@app/data/editEvent/api'

export default function useDeleteEvent() {
	const [deleteEvent, {isLoading, error, isSuccess}] = useDeleteEventMutation();

	const build = (orgId, eventId) => {
		deleteEvent({orgId, eventId})
	}

	if (error) {
		console.log('error while trying to delete', error)
	}

	return {build, isLoading, error, isSuccess}
}